import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';
import diagonals_background from '../../images/diagonal-lines-pattern.svg';
export const AIIconStyle = styled.div`
	position: absolute;
	bottom: 5px;
	left: 6px;
`;

// Marius: modalView property is still in discussion if it should be used. Currently hours input has a different design in most new modals

export const InputStyle = styled.input`
	width: ${props => props.width || '100%'};
	border-radius: 4px;
	border: solid ${props => (props.taskModalStyle || props.noBorder ? '0px' : '1px')} ${CSS_CONSTANTS.app_border_color};
	background-color: ${props => (props.taskModalStyle ? 'inherit' : CSS_CONSTANTS.color_white)};
	font-size: ${props => (props.modalView ? '12px' : props.taskModalStyle ? '15px' : '13px')};
	${props => (props.taskModalStyle ? 'font-weight: 700;' : '')};
	padding: ${props => (props.modalView ? '0 16px' : props.taskModalStyle ? '0' : '6px 16px 6px 10px')};
	line-height: ${props =>
		props.modalView ? 'normal' : '16px'}; /*if we don't set it the font height is 17px wich make the input too tall*/
	text-align: ${props => (props.alignLeft ? 'left' : 'right')};
	${props => (props.modalView ? 'flex: 0 1 auto;' : '')};
	color: ${props => (props.modalView ? 'inherit' : CSS_CONSTANTS.v2_text_gray)};
	height: ${props => (props.modalView ? '40px' : props.taskModalStyle ? '' : '30px')};
	${props => (props.modalView ? 'display: flex;' : '')};
	${props => (props.modalView ? 'flex-direction: row;' : '')};

	::-webkit-input-placeholder {
		/* Chrome/Opera/Safari */
		font-size: 13px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
	::-moz-placeholder {
		/* Firefox 19+ */
		font-size: 13px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
	:-ms-input-placeholder {
		/* IE 10+ */
		font-size: 13px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
	:-moz-placeholder {
		/* Firefox 18- */
		font-size: 13px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
	&.non-working-day {
		background-image: url(${diagonals_background});
		background-position: center;
		background-size: auto auto;
	}
	&:hover {
		border-color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
	}
	&:disabled,
	&.locked {
		color: ${props => (props.noLocked ? 'none' : CSS_CONSTANTS.v2_text_light_gray)};
		background-color: ${props => (props.noLocked ? 'none' : CSS_CONSTANTS.v2_input_disabled_grey)};
		border-color: ${props => (props.noLocked ? 'none' : CSS_CONSTANTS.app_border_color)};
	}
	&.error {
		border-color: ${CSS_CONSTANTS.negative_value};
	}
	&:focus {
		border-color: ${CSS_CONSTANTS.v2_branding_purple};
		outline: none;
	}
`;

export const InputTextStyle = styled(InputStyle)`
	text-align: left;
`;

export const HiddenSpanStyle = styled.span`
	display: inline-block;
	width: auto;
	visibility: hidden;
	position: fixed;
	overflow: auto;
	font-size: 20px;
	line-height: 28px;
	font-weight: 500;
	padding: 6px 16px 6px 10px;
`;

export const PageHeaderInputStyle = styled(InputStyle)`
	${props => (props.maxWidth ? 'max-width: 300px;' : '')};
	${props => (props.width ? 'width:' + props.width + 'px' : '')};
	${props => (props.transition ? 'transition: width 0.30s ease-in-out;' : '')};
	font-size: 20px;
	line-height: 28px;
	color: ${CSS_CONSTANTS.v2_text_gray};
	font-weight: 500;
	text-align: left;
	border-width: 0 0 1px;
	border-color: ${CSS_CONSTANTS.color_white};
	border-radius: 0px;
	padding-left: 0px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	&:focus {
		${props => (props.maxWidth ? 'width: 300px;' : '')};
	}
	&:hover {
		border-width: 0 0 1px;
	}
	::-webkit-input-placeholder {
		/* Chrome/Opera/Safari */
		font-size: 20px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
	::-moz-placeholder {
		/* Firefox 19+ */
		font-size: 20px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
	:-ms-input-placeholder {
		/* IE 10+ */
		font-size: 20px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
	:-moz-placeholder {
		/* Firefox 18- */
		font-size: 20px;
		color: ${CSS_CONSTANTS.v2_button_very_light_grey_hovered};
		opacity: 1;
	}
`;

export const InputContainerStyle = styled.div`
	position: relative;
	display: flex;
	${props => (props.noMaxWidth ? 'max-width: 90px;' : 'max-width: 100%;')}
	${props => (props.modalView || props.taskModalStyle ? '' : 'height: 30px;')}
	flex-direction: column;
`;

export const InputLabelStyle = styled.label`
	height: 11px;
	font-size: 9px;
	font-weight: 400;
	line-height: 1.22;
	letter-spacing: 1px;
	${props => (props.alignRight ? 'text-align: right;' : '')}
	color: ${CSS_CONSTANTS.v2_text_light_gray};
	text-transform: uppercase;
	margin-bottom: 5px;
	display: inline-block;
	white-space: nowrap;
	.required-extension {
		&:not(.inactive) {
			color: ${CSS_CONSTANTS.negative_value};
		}
		text-transform: none;
		font-size: 8px;
		margin-left: 5px;
	}
`;

export const LockedIconStyle = styled.span`
	position: absolute;
	bottom: -6px;
	left: -2px;
`;
